// ErrorBoundary.js
import React, { Component } from 'react';

class ExceptionHandler extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    componentDidCatch(error, errorInfo) {
        // Log the error to an error reporting service (e.g., Sentry)
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
        this.setState({ hasError: true });
    }
    render() {
        if (this.state.hasError) {
            return <div>Something went wrong. Please try again later.</div>;
        }
        return this.props.children;
    }
}
export default ExceptionHandler;